import Icon from '../components/Icon.vue'

Icon.register({
  tape: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M224 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM624 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-400c-123.7 0-224-100.3-224-224s100.3-224 224-224 224 100.3 224 224c0 62.7-25.9 119.3-67.4 160h243.4zM224 352c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96z'
      }
    ]
  }
})
